import { IArchiveI9Repository } from '../ports/outbound/IArchiveI9Repository';

export class ArchiveI9UseCase {
  constructor(private repo: IArchiveI9Repository) {}

  async execute(i9FormId: string, reason: string): Promise<string> {
    return this.repo.archive(i9FormId, reason);
  }
}
